const getHighestQualityImage = (imageLinks) => {
  if (!imageLinks) return "";

  // Order from highest to lowest quality
  const imageVersions = [
    "extraLarge", // 1280px
    "large", // 800px
    "medium", // 300px
    "small", // 180px
    "thumbnail", // 128px
    "smallThumbnail", // 80px
  ];

  // Find the highest quality available image
  for (const version of imageVersions) {
    if (imageLinks[version]) {
      let imageUrl = imageLinks[version]
        .replace(/^http:/, "https:")
        .replace(/&edge=curl/, ""); // Remove book curl effect

      // If it's a thumbnail or small image, try to increase zoom for better quality
      if (version === "thumbnail" || version === "smallThumbnail" || version === "small") {
        // If no zoom parameter exists, add zoom=1 for better quality
        if (!imageUrl.includes("zoom=")) {
          imageUrl += "&zoom=1";
        }
      }

      return imageUrl;
    }
  }

  // Fallback to thumbnail if nothing else is available
  if (imageLinks.thumbnail) {
    let fallbackUrl = imageLinks.thumbnail.replace(/^http:/, "https:");
    if (!fallbackUrl.includes("zoom=")) {
      fallbackUrl += "&zoom=1";
    }
    return fallbackUrl;
  }

  return "";
};

export { getHighestQualityImage };
